import { Divider, Empty, Space, Table } from 'antd';

import { RequestInfo } from '@component/request-info/request-info';
import { ResponseInfo } from '@component/response-info/response-info';
import { requestSubLogsInfo } from '@component/tables/request-logs/request-sub-logs/request-sub-logs-info/request-sub-logs-info';
import { RequestInterface } from '@interface/logs/logs.interface';
import { isExist } from '@util/data/is-exist';

import { consumerSubLogsColumns } from './request-sub-logs.options';

export const requestSubLogs = (request: RequestInterface) => (
  <>
    <Space direction='vertical' size={16}>
      <RequestInfo request={request.request} />
      <ResponseInfo response={request.response} />
    </Space>
    {isExist(request.subRequests) && (
      <>
        <Divider orientation='left'>Sub Requests</Divider>
        <Table
          columns={consumerSubLogsColumns}
          dataSource={request.subRequests}
          expandable={{ expandedRowRender: requestSubLogsInfo }}
          locale={{ emptyText: <Empty description='No sub logs' image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
          pagination={false}
          rowKey='id'
        />
      </>
    )}
  </>
);
